import styles from './Message.module.scss'
import BasicTitle from 'components/about/BasicTitle/BasicTitle'
import React, { useRef } from 'react'
import Button from 'components/common/Button/Button'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'

const Message: React.FC = () => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const isVisible = useElementVisible(textRef, 0.1)

  const sectionTitle = {
    title: 'Message',
    sub_title: '代表メッセージ',
  }

  return (
    <section className={`${styles.contents} message_wrapper `} id="message_top">
      <div className={styles.title_group}>
        <BasicTitle sectionTitle={sectionTitle} />
      </div>
      <div
        className={`${styles.content} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
        ref={textRef}
      >
        <picture className={styles.img_group}>
          <source srcSet="/images/img/service/img_ceo.png" media="(min-width: 820px)" />
          <img src="/images/img/service/img_ceo_sp.png" alt="代表取締役社長 CEO 芝 陽一郎" />
        </picture>
        <div className={styles.right_group}>
          <div className={styles.name_group_container}>
            <div className={styles.director_container}>
              <p className={styles.director}>代表取締役社長</p>
              <p className={styles.director}>CEO</p>
            </div>
            <div className={styles.name_group}>
              <div className={styles.container}>
                <h3 className={styles.shiba}>芝 陽一郎</h3>
              </div>
              <p className={styles.sub_name}>Yoichiro Shiba</p>
            </div>
          </div>
          <div className={styles.message_group}>
            <p className={styles.message}>
              IMD世界デジタル競争力ランキングで日本は30位──技術力がありながらも変革のスピードを上げ切れていない現実があります。しかし今、生成AIと自律型AIエージェントの急速な普及により、アイデアを即座に形にできる環境が整いました。日本が再び世界を驚かせる、まさに絶好のタイミングです。
            </p>
            <p className={styles.message}>
              AitriaはAI駆動のデジタルエンジニアリング企業として、Design × AI ×
              Engineeringを統合し、日本のITを再起動します。AI駆動開発、UX/UIの卓越性、クラウドネイティブを武器に、モダナイゼーションとAIシフトを実装します。UX/UIの卓越性とデザインシステムによる再現性・拡張性、Agile
              × CI/CD ×
              DevOpsを軸にした高アジリティなクラウドネイティブ開発、そしてAI駆動の開発ワークフローを融合させています。
            </p>
            <p className={styles.message}>
              私たちが掲げるビジョンは、「日本のITを再起動する最高のチーム」です。テクノロジーとデザインの力で企業の変革を加速させ、この国のデジタル競争力を世界トップレベルへ押し上げる──それが私たちの使命です。
            </p>
            <p className={styles.message}>
              いま求めているのは、未知に挑み、自ら学習し続ける意志を持つ仲間です。生成AIの進化に自身の可能性を重ね、俊敏な開発スタイルでユーザー体験とビジネス価値を同時に高めるプロダクトを共創したい方を歓迎します。
            </p>
            <p className={styles.message}>
              次の時代を動かすのは、あなたの好奇心と私たちのプラットフォームです。「最高のチーム」の一員として、共に日本のITを再起動し、世界に驚きを届けましょう。
            </p>
          </div>
          <div className={styles.introduction}>
            <p>
              野村総合研究所にて金融機関むけのシステムコンサルティング業務に従事後、ソフトバンクにて海外ベンチャーキャピタルとの折衝、投資案件のデューデリを担当。当時ソフトバンクグループ会社内の最年少役員。その後、一部上場企業を対象に投資事業ポートフォリオ再編、バイアウトのアドバイザリー業務を提供、複数のIT企業の役員歴任。早稲田大学人間科学研究科修士課程修了。ロータリー財団の奨学生としてドイツBielefeld大学にて社会哲学専攻。渡航国36カ国120都市。
            </p>
          </div>
          <div className={styles.ceoSNS}>
            <ul className={styles.ceoSNS__list}>
              <li className={styles.ceoSNS__list__item}>
                <a href="https://x.com/you_shiba" target="_blank" className={styles.ceoSNS__x}>
                  （旧Twitter）
                </a>
              </li>
              <li className={styles.ceoSNS__list__item}>
                <a href="https://note.com/yoichiro_shiba" target="_blank" className={styles.ceoSNS__note}>
                  　
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Message
